import { replayPillLabel } from '@/lib/replay-mark';
import type { ReplayMode } from '@matter_extractor/shared';

/**
 * The violet pill of a replay (rejeu.md §12, issue #193): « rejeu · strict » or
 * « rejeu · complété ».
 *
 * One component for the three places that wear it - the column Lien of the list,
 * the head of the parcours and the head of the conversation - so the three read
 * the same. Violet (`violet-tint`, `violet-deep`) because no status and no
 * version carries it: it cannot be mistaken for « en cours » (bleu ciel) or for a
 * development version.
 *
 * Still written here and not the package's `Badge`: none of its six tones is
 * violet, and a violet that became one of them would read as a status. The
 * shape follows the `Badge` (pill, 2 × 8 px, 12 px semi-bold) so the two sit
 * side by side on a line without a jump.
 *
 * It says the MODE and nothing else. What the replay was played FROM is the
 * label under it on the list, and the panel of the parcours.
 */

export interface ReplayPillProps {
  readonly mode: ReplayMode;
  /** The mark a suite reads this pill by; it differs on the three screens. */
  readonly testId: string;
}

export function ReplayPill({ mode, testId }: ReplayPillProps) {
  return (
    <span
      data-testid={testId}
      data-mode={mode}
      // pms-design-exception: padding of 2 x 8 px of the package Badge, whose violet tone is missing
      className="inline-flex items-center whitespace-nowrap rounded-full bg-violet-tint px-2 py-0.5 align-middle font-semibold text-badge text-violet-deep"
    >
      {replayPillLabel(mode)}
    </span>
  );
}
